import {
    EVIDENCE_ADD_REQUEST,
    EVIDENCE_ADD_RESPONSE,
    EVIDENCE_ITEM_DELETE_RESPONSE,
    EVIDENCE_ITEM_ERROR_RESPONSE,
    EVIDENCE_ITEM_SAVE_RESPONSE,
    EVIDENCE_LIST_CACHED_RESPONSE,
    EVIDENCE_LIST_REQUEST,
    EVIDENCE_LIST_RESPONSE,
    EVIDENCE_REMOVE_ITEM,
    ROLE_ADD,
    ROLE_ITEM_SAVE_RESPONSE,
    ROLE_LIST_RESPONSE,
    ROLE_REMOVE,
    STAKEHOLDER_CANCEL_MODEL_UPDATE,
    STAKEHOLDER_FINISH_SAVING,
    STAKEHOLDER_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"

const defaultState = {}

/*
 exampleState = {
  "roleID": {
    isFetchingList: true,
    view: : [{...evidenceItem...}, {...evidenceItem...}],
    edit: [{...evidenceItem...}, {...evidenceItem...}]
  }
}
*/

export default (state = defaultState, action) => {
    const { type, data, roleID } = action
    switch (type) {
        case ROLE_LIST_RESPONSE:
            return action.data.reduce((accumulator, role) => {
                accumulator[role.id] = {
                    view: [],
                    edit: []
                }
                return accumulator
            }, state)
        case ROLE_ITEM_SAVE_RESPONSE:
            return {
                ...state,
                [action.item.id]: {
                    view: [],
                    edit: []
                }
            }
        case ROLE_REMOVE:
            return {
                ...state,
                [action.roleID]: {
                    ...state[action.roleID],
                    edit: []
                }    
            }
        case ROLE_ADD:
            return {
                ...state,
                [action.role.id]: {
                    view: [],
                    edit: []
                }
            }
        case EVIDENCE_LIST_REQUEST:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    isFetchingList: true
                }
            }
        case EVIDENCE_LIST_RESPONSE:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    isFetchingList: false,
                    view: data,
                    edit: data
                }
            }
        case EVIDENCE_LIST_CACHED_RESPONSE:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    isFetchingList: false
                }
            }
        case EVIDENCE_ADD_REQUEST:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    isSaving: true
                }
            }
        case EVIDENCE_ADD_RESPONSE:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    isSaving: false,
                    edit: [
                        ...state[roleID].edit,
                        {
                            ...action.item,
                            saveStatus: "POST"
                        }
                    ]
                }
            }
        case EVIDENCE_ITEM_ERROR_RESPONSE:
            const { id } = action
            return {
                ...state,
                [id]: {
                    ...state[id],
                    isSaving: false
                }
            }
        case EVIDENCE_REMOVE_ITEM:
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    edit: state[roleID].edit.map(item => {
                        if (item.link === action.item.link) {
                            return {
                                ...item,
                                saveStatus: "DELETE"
                            }
                        } else {
                            return item
                        }
                    })
                }
            }
        case EVIDENCE_ITEM_SAVE_RESPONSE: {
            const newEdit = state[roleID].edit.map(item => {
                if (!item.id && item.link === action.item.link) {
                    return {
                        ...item,
                        ...action.item,
                        saveStatus: null
                    }
                } else {
                    return item
                }
            })
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    view: newEdit,
                    edit: newEdit
                }
            }
        }
        case EVIDENCE_ITEM_DELETE_RESPONSE: {
            const newEdit = state[roleID].edit.filter(
                item => item.id !== action.evidenceID
            )
            return {
                ...state,
                [roleID]: {
                    ...state[roleID],
                    view: newEdit,
                    edit: newEdit
                }
            }
        }
        case STAKEHOLDER_LIST_RESPONSE:
            return data.reduce((accumulator, stakeholder) => {
                stakeholder.roles.forEach(role => {
                    accumulator[role.id] = {
                        ...accumulator[role.id],
                        view: [],
                        edit: []
                    }
                })
                return accumulator
            }, state)
        case STAKEHOLDER_CANCEL_MODEL_UPDATE:
            return Object.keys(state).reduce((accumulator, roleID) => {
                accumulator[roleID] = {
                    ...state[roleID],
                    edit: state[roleID].view
                }
                return accumulator
            }, state)
        case STAKEHOLDER_FINISH_SAVING:
            const validRoleIDs = Object.keys(state).filter(
                roleID => roleID && roleID.length > 11
            )

            return validRoleIDs.reduce((accumulator, roleID) => {
                accumulator[roleID] = state[roleID]
                return accumulator
            }, {})

        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
